export class Util {
    public static param(params):string {
        return Object.keys(params).reduce(function (a, k) {
            a.push(k + '=' + encodeURIComponent(params[k]));
            return a;
        }, []).join('&');
    }

    public static dateToInputFormat(date:Date):string {
        var day = date.getDate().toString();
        if (day.length <= 1) {
            day = "0" + day;
        }
        var month = (date.getMonth() + 1).toString();
        if (month.length <= 1) {
            month = "0" + month;
        }
        var year = date.getFullYear();

        return year + "-" + month + "-" + day;
    }
}